/**
 * Length caps for free-text fields that land in VARCHAR(255) columns on the
 * submission (title, FNI, account manager name and email).
 *
 * The API does not validate these lengths yet: anything longer fails the
 * write with a 500 (OR-1655). Capping the inputs keeps the user from ever
 * sending a value the backend cannot store.
 */
export const SUBMISSION_TEXT_MAX_LENGTH = 255;

/** Hint text under a capped field, same wording as the Notes field in UW Information. */
export function charactersLeft(value: string | null | undefined, max = SUBMISSION_TEXT_MAX_LENGTH): string {
    const remaining = Math.max(0, max - (value?.length ?? 0));
    return `${remaining} characters left`;
}
